"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _showMore = _interopRequireDefault(require("../show-more"));

var _results = _interopRequireDefault(require("./results"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var propTypes = {
  /** Array of results to display */
  documentsList: (0, _propTypes.arrayOf)(_propTypes.object).isRequired,

  /** Default handler for download item onClick */
  downloadAction: _propTypes.func,

  /** Number of maximum items to show */
  maxItemsToShow: _propTypes.number,

  /** Handler to be called when the show more button is clicked */
  moreButtonOnClick: _propTypes.func
};

var DocumentsPane = function DocumentsPane(_ref) {
  var downloadAction = _ref.downloadAction,
      maxItemsToShow = _ref.maxItemsToShow,
      moreButtonOnClick = _ref.moreButtonOnClick,
      documentsList = _ref.documentsList;

  var _useToggle = (0, _utils.useToggle)(false),
      showAllResults = _useToggle[0],
      showMoreOnClick = _useToggle[1];

  var showMoreHandler = (0, _react.useCallback)(function (event) {
    if ((0, _ramda.is)(Function, moreButtonOnClick)) {
      moreButtonOnClick({
        event: event
      });
    } else {
      showMoreOnClick();
    }
  }, [moreButtonOnClick, showMoreOnClick]);
  var showMoreButton = (0, _ramda.length)(documentsList) > maxItemsToShow;
  var visibleItems = showAllResults || !maxItemsToShow ? documentsList : (0, _ramda.take)(maxItemsToShow, documentsList);
  var extraItemsCount = showAllResults ? 0 : (0, _ramda.subtract)((0, _ramda.length)(documentsList), maxItemsToShow);
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    as: "section",
    flexDirection: "column",
    pb: [5],
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    width: 1
  }, (0, _ramda.length)(visibleItems) > 0 && /*#__PURE__*/_react["default"].createElement(_results["default"], {
    downloadAction: downloadAction,
    visibleItems: visibleItems
  }), showMoreButton && /*#__PURE__*/_react["default"].createElement(_showMore["default"], {
    delayIn: visibleItems.length * 0.04,
    extraItemsCount: extraItemsCount,
    showAllResults: showAllResults,
    showMoreOnClick: showMoreHandler
  })));
};

DocumentsPane.propTypes = propTypes;
DocumentsPane.displayName = "Modules.DocumentsPane";
var _default = DocumentsPane;
exports["default"] = _default;